
import React from "react";

export default function ShoppingList({
  shoppingList,
  setShoppingList,
  addedToTesco,
  setAddedToTesco,
  recipes = [],
  recipesInShoppingList = [],
  setRecipesInShoppingList
}) {
  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">Shopping List</h2>
      {shoppingList.length === 0 ? (
        <p className="text-gray-500">No items in your shopping list.</p>
      ) : (
        <>
          <div className="mb-4">
            <div className="grid grid-cols-1">
              <div className="flex font-semibold border-b pb-2 mb-2 text-left">
                <div className="w-20"></div>
                <div className="flex-1">Item</div>
                <div className="w-20 text-center">Price</div>
                <div className="w-20 text-center">Qty</div>
                <div className="w-32 text-center">Actions</div>
              </div>
              {shoppingList.map((item, idx) => {
                const isAdded = addedToTesco.includes(item.title);
                return (
                  <div
                    key={idx}
                    className={`flex items-center border-b py-2 text-left transition-colors duration-300 ${isAdded ? 'bg-gray-200 opacity-60' : ''}`}
                  >
                    <div className="w-20 flex justify-center">
                      {item.image && (
                        <img src={item.image} alt={item.title} className="w-12 h-12 object-contain" />
                      )}
                    </div>
                    <div className="flex-1 font-medium">{item.title}</div>
                    <div className="w-20 text-center">{item.price}</div>
                    <div className="w-20 flex items-center justify-center gap-2">
                      <button
                        className="bg-red-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs hover:bg-red-700"
                        onClick={() => setShoppingList((prev) => {
                          // Remove one
                          return prev
                            .map((it, i) => i === idx ? { ...it, quantity: it.quantity - 1 } : it)
                            .filter((it) => it.quantity > 0);
                        })}
                        title="Remove one"
                      >
                        -
                      </button>
                      <span className="font-bold">{item.quantity || 1}x</span>
                      <button
                        className="bg-green-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs hover:bg-green-700"
                        onClick={() => setShoppingList((prev) => prev.map((it, i) => i === idx ? { ...it, quantity: (it.quantity || 1) + 1 } : it))}
                        title="Add one more"
                        disabled={isAdded}
                      >
                        +
                      </button>
                    </div>
                    <div className="w-32 flex gap-2 justify-center">
                      <a
                        className={`px-2 py-1 rounded text-xs text-center ${isAdded ? 'bg-gray-400 text-white' : 'bg-blue-600 text-white hover:bg-blue-700'}`}
                        href={`https://www.tesco.com/groceries/en-GB/search?query=${encodeURIComponent(item.title + ' ' + (item.price || ''))}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        title="Open Tesco search for this item"
                        onClick={() => {
                          if (!isAdded) setAddedToTesco((prev) => [...prev, item.title]);
                        }}
                      >
                        {isAdded ? 'Added' : 'Add'}
                      </a>
                      <button
                        className="bg-gray-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs hover:bg-gray-800"
                        onClick={() => setShoppingList((prev) => prev.filter((_, i) => i !== idx))}
                        title="Remove all"
                      >
                        ×
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="text-right font-bold text-lg">
            Total: £{
              shoppingList
                .reduce((sum, item) => sum + ((parseFloat(item.price.replace('£','')) || 0) * (item.quantity || 1)), 0)
                .toFixed(2)
            }
          </div>
        </>
      )}
      {/* Tesco iframe for manual add - removed, as Tesco blocks embedding */}

      {/* Recipes in shopping list */}
      {recipesInShoppingList.length > 0 && (
        <div className="mt-8 border-t pt-4">
          <h3 className="text-lg font-semibold mb-2">Recipes in Shopping List</h3>
          <ul>
            {recipesInShoppingList.map((rid) => {
              const recipe = recipes.find(r => r.id === rid);
              if (!recipe) return null;
              return (
                <li key={rid} className="flex items-center justify-between mb-2">
                  <span>{recipe.title}</span>
                  <button
                    className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700 text-xs"
                    onClick={() => {
                      // Remove all recipe ingredients from shopping list
                      setShoppingList(prev => {
                        let updated = [...prev];
                        recipe.ingredients.forEach((ingredient) => {
                          const qty = ingredient.quantity || 1;
                          const idx = updated.findIndex((item) => item.title === ingredient.title);
                          if (idx !== -1) {
                            if ((updated[idx].quantity || 1) > qty) {
                              updated[idx] = { ...updated[idx], quantity: (updated[idx].quantity || 1) - qty };
                            } else {
                              updated = updated.filter((_, i) => i !== idx);
                            }
                          }
                        });
                        return updated;
                      });
                      // Remove recipe from recipesInShoppingList
                      if (setRecipesInShoppingList) {
                        setRecipesInShoppingList(arr => arr.filter(id => id !== rid));
                      }
                    }}
                  >Remove</button>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
}
